import {
  CCM_RESET_TIMER,
  CCM_START_TIMER,
  CCM_STOP_TIMER,
  GENERATE_DOB_FOR_CCM_USER_ROLE,
  SET_UPCOMING_APPOINTMENT_DATA,
  SINGLE_CCM_PATIENT_DETAILS,
  START_TIMER_FROM_PATIENT_DRAWER,
  UPDATE_CCM_PATIENT_DEFAULT_STATE,
  UPDATE_FOLLOW_UP_DUE_DATE_AND_ASSIGNEE,
  UPDATE_FOLLOW_UP_NOTES,
  UPDATE_STOP_TIMER_NOTES
} from '../actions/Index';

interface TimerState {
  clinicId: number | null;
  patientId: string;
  ccmPatientId: number | null;
  guarantorId?: number | null;
  isPlanActive: boolean;
  isExternalPlanActive?: boolean;
  patientName: string;
  accountNumber: number | null;
  guarantorNotificationPhone?: string | number;
  startTimerfromPatientDrawer: boolean;
  startTime: number | null;
  stopTime: number | null;
  isTimerRunning: boolean;
  isSinglePatientSearch: boolean;
  stopTimerNotes: string;
  followUpNotes: string;
  ccmPatientTabDefaultState: {
    showPassed?: boolean;
    clinicId?: string | number;
  } | null;
  // showPassedCCMPatientTab
  // prevFollowUpNotes: string;
  // prevFollowUpNotesLogId?: number;
  upcomingAppointmentData: any;
  followUpDueDateAndAssigneeObj: any;
  dobKey: any;
}

const initialTimerState: TimerState = {
  clinicId: null,
  patientId: '',
  ccmPatientId: null,
  guarantorId: null,
  isPlanActive: false,
  isExternalPlanActive: false,
  patientName: '',
  accountNumber: null,
  guarantorNotificationPhone: '',

  startTimerfromPatientDrawer: false,
  startTime: null,
  stopTime: null,
  isTimerRunning: false,
  isSinglePatientSearch: false,
  stopTimerNotes: '',
  followUpNotes: '',
  upcomingAppointmentData: null,
  ccmPatientTabDefaultState: null,
  followUpDueDateAndAssigneeObj: null,
  dobKey: null
};

export const CCMTimerReducer = (state = initialTimerState, action: any) => {
  switch (action.type) {
    case CCM_START_TIMER:
      return {
        ...state,
        startTime: action.payload.startTime,
        isTimerRunning: true,
        ccmPatientId: action.payload.ccmPatientId
      };
    case CCM_STOP_TIMER:
      return {
        ...state,
        stopTime: action.payload.stopTime,
        isTimerRunning: action.payload.stopTimer
          ? action.payload.stopTimer
          : state.isTimerRunning
      };

    case CCM_RESET_TIMER:
      return {
        stopTime: null,
        startTime: null,
        isTimerRunning: false,
        patientId: '',
        ccmPatientId: null,
        stopTimerNotes: '',
        followUpNotes: '',
        startTimerfromPatientDrawer: false
      };
    case SINGLE_CCM_PATIENT_DETAILS: {
      const updatedValues = {
        ccmPatientId: action.payload.ccmPatientId,
        patientName: action.payload.patientName,
        accountNumber: action.payload.accountNumber,
        isSinglePatientSearch: action.payload.isSinglePatientSearch,
        patientId: action.payload.patientId,
        clinicId: action.payload.clinicId,
        guarantorId: action.payload.guarantorId,
        isPlanActive: action.payload.isPlanActive,
        isExternalPlanActive: action.payload.isExternalPlanActive,
        guarantorNotificationPhone: action.payload.guarantorNotificationPhone
      };
      if (state.isTimerRunning) return state;
      return {
        ...state,
        ...updatedValues
      };
    }
    case START_TIMER_FROM_PATIENT_DRAWER:
      return {
        ...state,
        startTimerfromPatientDrawer: action.payload.startTimerfromPatientDrawer
      };
    case UPDATE_STOP_TIMER_NOTES:
      return {
        ...state,
        stopTimerNotes: action.payload.stopTimerNotes
      };
    case UPDATE_FOLLOW_UP_NOTES:
      return {
        ...state,
        followUpNotes: action.payload.followUpNotes
      };
    case SET_UPCOMING_APPOINTMENT_DATA:
      return {
        ...state,
        upcomingAppointmentData: action.payload.upcomingAppointmentData
      };
    case UPDATE_CCM_PATIENT_DEFAULT_STATE: {
      if (action.payload.ccmPatientTabDefaultState) {
        return {
          ...state,
          ccmPatientTabDefaultState: {
            ...action.payload.ccmPatientTabDefaultState
          }
        };
      } else {
        return {
          ...state,
          ccmPatientTabDefaultState: null
        };
      }
    }
    case UPDATE_FOLLOW_UP_DUE_DATE_AND_ASSIGNEE: {
      if (action.payload.followUpDueDateAndAssigneeObj) {
        const newDateAndAssignee = state.followUpDueDateAndAssigneeObj
          ? state.followUpDueDateAndAssigneeObj
          : {};
        return {
          ...state,
          followUpDueDateAndAssigneeObj: {
            ...newDateAndAssignee,
            ...action.payload.followUpDueDateAndAssigneeObj
          }
        };
      } else {
        return {
          ...state,
          followUpDueDateAndAssigneeObj: null
        };
      }
    }
    case GENERATE_DOB_FOR_CCM_USER_ROLE:
      return {
        ...state,
        dobKey: action.payload.dobKey
      };
    default:
      return state;
  }
};
